import React, { useCallback, useMemo } from "react";
import { TooltipIcon } from "components/InputCards/TooltipIcon";
import { useTranslate } from "hooks";
import { Select } from "components/Select/Select";

export const RangeSelectCard = ({
  value,
  signatures,
  onChange,
  partKey,
  optionKey,
  disabled,
  max,
  min,
  description,
  label,
}) => {
  const translate = useTranslate();
  const options = useMemo(
    () =>
      signatures
        .filter((item) => !item.state)
        .map((item) => ({
          value: item.value,
          label: item.value,
        })),
    [signatures],
  );

  const selectValue = useMemo(() => ({ value, label: value }), [value]);

  const handleChange = useCallback(
    (selectedOption) => {
      onChange({
        changeData: { data: selectedOption.value, partKey, optionKey },
      });
    },
    [onChange, optionKey, partKey],
  );

  const handleValidate = useCallback(
    (val) => {
      const numberVal = Number(val);
      return !(isNaN(numberVal) || numberVal < min || numberVal > max);
    },
    [max, min],
  );

  return (
    <>
      <TooltipIcon description={description} />
      {label && <h5 className="">{label}</h5>}
      <div className="d-flex flex-nowrap align-items-center w-100">
        <Select
          isClearable={false}
          options={options}
          value={selectValue}
          onChange={handleChange}
          isDisabled={disabled}
          formatCreateLabel={(val) => `${translate("CREATE")} "${val}"`}
          isValidNewOption={handleValidate}
          className="flex-grow-1"
          isCreatable={true}
        />
        <span
          className="ms-2 font-size-sm text-gray-500 text-end"
          style={{ minWidth: "70px" }}
        >
          {min} ... {max}
        </span>
      </div>
    </>
  );
};
